import { IAnalogSetpoint } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import {
    Checkbox,
    STYLE_TYPE
} from "baseui/checkbox";
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';
import { themedUseStyletron } from '../../../theme/customTheme';

export function OverviewPanel(props: IAnalogSetpoint) {
    const [css, theme] = themedUseStyletron();
    const [value, setValue,] = useSetObjectValue(props.id, props.resourceGroupId, "value", props.value);
    const onValueChanged = (e: any) => {
        if (e)
            setValue(true);
        else
            setValue(false);
    }

    return (
        <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props}>
            <div className={css({ maxWidth: '150px' })}>
                <Checkbox
                    checked={value}
                    checkmarkType={STYLE_TYPE.toggle_round}
                    onChange={(e: any) => { e.stopPropagation();  e.preventDefault();  onValueChanged(e.target.checked) }}>
                    {value ? <FormattedMessage id='on' defaultMessage='ON'></FormattedMessage> : <FormattedMessage id='off' defaultMessage='OFF'></FormattedMessage>}
                </Checkbox>
            </div>
        </OverviewPanelWrapper>
    );
}